// eslint-disable-next-line import/no-internal-modules
import AlertComponent from '@insided/deprecated-control/ui-components/AlertComponent'

const ErrorList = ({ errors = [] }: { errors: Array<{errorMessage: string | JSX.Element}> | Array<{category: string, phrase: string }> }) => {
  if (!errors.length) return null

  return (
    <div className='content-errors'>
      {
      errors.map((error, index) =>
        <AlertComponent messageType='error' message={'errorMessage' in error ? error.errorMessage as string : null} key={index} />
      )
    }
    </div>
)
}

export default ErrorList
